import PreviewModalDownloadButton from './PreviewModalDownloadButton.component';

export default PreviewModalDownloadButton;
